import { render, staticRenderFns } from "./callExample.vue?vue&type=template&id=ced266a6&scoped=true&"
import script from "./callExample.vue?vue&type=script&lang=js&"
export * from "./callExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced266a6",
  null
  
)

export default component.exports